import { render, staticRenderFns } from "./SectionEditorHeader.vue?vue&type=template&id=2a969df9"
import script from "./SectionEditorHeader.vue?vue&type=script&lang=ts"
export * from "./SectionEditorHeader.vue?vue&type=script&lang=ts"
import style0 from "./SectionEditorHeader.vue?vue&type=style&index=0&id=2a969df9&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports